import {
  PARTNER_DATA_CORE_EDIT_HISTORY_HIDDEN_ATTRIBUTES,
  PARTNER_DATA_SECTION_NAME,
} from 'views/RevisionHistory/Partner/hidden-attributes/partner-data-core-hidden-attributes';
import {
  PARTNER_PROFILE_EDIT_HISTORY_HIDDEN_ATTRIBUTES,
  PARTNER_PROFILE_SECTION_NAME,
} from 'views/RevisionHistory/Partner/hidden-attributes/partner-profile-hidden-attributes';
import {
  RISK_PROFILE_EDIT_HISTORY_HIDDEN_ATTRIBUTES,
  RISK_PROFILE_SECTION_NAME,
} from 'views/RevisionHistory/Partner/hidden-attributes/risk-profile-hidden-attributes';
import {
  P2P_RELATIONS_EDIT_HISTORY_HIDDEN_ATTRIBUTES,
  P2P_RELATIONS_SECTION_NAME,
} from 'views/RevisionHistory/Partner/hidden-attributes/p2p-relations-hidden-attributes';
import {
  WEALTH_OVERVIEW_EDIT_HISTORY_HIDDEN_ATTRIBUTES,
  WEALTH_OVERVIEW_SECTION_NAME,
} from 'views/RevisionHistory/Partner/hidden-attributes/wealth-overview-hidden-attributes';

const createUniqueAttributesToHideList = (attrList: string[], sectionName: string) =>
  attrList.map((attr) => `${sectionName}#${attr}`);

export const EDIT_HISTORY_HIDDEN_ATTRIBUTES = [
  ...createUniqueAttributesToHideList(PARTNER_DATA_CORE_EDIT_HISTORY_HIDDEN_ATTRIBUTES, PARTNER_DATA_SECTION_NAME),
  ...createUniqueAttributesToHideList(PARTNER_PROFILE_EDIT_HISTORY_HIDDEN_ATTRIBUTES, PARTNER_PROFILE_SECTION_NAME),
  ...createUniqueAttributesToHideList(RISK_PROFILE_EDIT_HISTORY_HIDDEN_ATTRIBUTES, RISK_PROFILE_SECTION_NAME),
  ...createUniqueAttributesToHideList(P2P_RELATIONS_EDIT_HISTORY_HIDDEN_ATTRIBUTES, P2P_RELATIONS_SECTION_NAME),
  ...createUniqueAttributesToHideList(WEALTH_OVERVIEW_EDIT_HISTORY_HIDDEN_ATTRIBUTES, WEALTH_OVERVIEW_SECTION_NAME),
];
